/**
 * Derive a URL-safe slug from a display name (lowercase, non-alphanumeric → hyphen).
 */
export function slugifyName(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Normalize manual slug input (same rules as slugifyName).
 */
export function normalizeSlugInput(value) {
  return slugifyName(value);
}

/**
 * @param {string} slug
 * @param {string} name
 * @param {string[]} existingSlugs
 * @param {{ ignoreSlug?: string }} [options] - ignoreSlug: current slug when editing (immutable)
 * @returns {string|null} user-facing error or null
 */
export function getSlugConflictMessage(slug, name, existingSlugs, options = {}) {
  const ignore = String(options.ignoreSlug || '').trim().toLowerCase();
  const normalized = slugifyName(slug);
  const displayName = String(name || '').trim();

  if (!displayName || !normalized) return null;

  const taken = (existingSlugs || []).some((existing) => {
    const e = String(existing || '').trim().toLowerCase();
    if (!e || e === ignore) return false;
    return e === normalized;
  });

  if (!taken) return null;
  return 'This name produces a slug that already exists. Change the name to create a unique identifier.';
}

export function isSlugAvailable(slug, existingSlugs, options = {}) {
  return !getSlugConflictMessage(slug, slug || 'x', existingSlugs, options);
}
